import { useEffect, useRef } from "react";

const resultados = [
  {
    icon: "ri-money-dollar-circle-line",
    title: "Redução de custos",
    desc: "Otimizamos contratos e identificamos gorduras operacionais que reduzem o gasto com benefícios em até 35%.",
    stat: "Tranformamos despezas em lucro!",
  },
  {
    icon: "ri-shield-check-line",
    title: "Controle de sinistralidade",
    desc: "Monitoramento preditivo e gestão ativa de saúde que reduzem a sinistralidade de até 70% do plano.",
    stat: "Economia de até 70%",
  },
  {
    icon: "ri-hospital-line",
    title: "Diminuição do absenteísmo",
    desc: "Saúde preventiva e bem-estar emocional que reduzem em até 80% faltas e afastamentos, aumentando a produtividade do time.",
    stat: "Redução de até 80%",
  },
  {
    icon: "ri-user-heart-line",
    title: "Retenção de talentos",
    desc: "Benefícios estratégicos alinhados à cultura da empresa aumentam o engajamento e mantêm os melhores talentos por mais tempo.",
    stat: "Até 100% de retenção de talentos",
  },
  {
    icon: "ri-line-chart-line",
    title: "Aumento de produtividade",
    desc: "Colaboradores mais saudáveis e engajados produzem mais. Nossas soluções impactam diretamente no resultado.",
    stat: "Aumento de até 80% na produtividade",
  },
  {
    icon: "ri-compass-3-line",
    title: "Apoio estratégico",
    desc: "Dashboards executivos e relatórios de dados para que a diretoria tome decisões com base em evidências, não suposições.",
    stat: "Real-time",
  },
];

export default function Resultados() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".res-card").forEach((card, i) => {
              setTimeout(() => card.classList.add("res-visible"), i * 80);
            });
          }
        });
      },
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="resultados" className="py-16 lg:py-20 bg-[#0D0D0D] overflow-hidden" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="w-6 h-px bg-[#FBC52D]" />
            <span className="text-[#FBC52D] text-xs font-semibold tracking-widest uppercase">
              Resultados mensuráveis
            </span>
            <span className="w-6 h-px bg-[#FBC52D]" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
            Fortalecemos pessoas. Aceleramos resultados.
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed">
            A Ferrarezi não vende apenas benefícios e seguros. Nós ajudamos empresas a alcançar resultados concretos, com dados que comprovam o impacto.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {resultados.map((res) => (
            <div
              key={res.title}
              className="res-card opacity-0 translate-y-6 transition-all duration-500 group bg-white/5 border border-white/8 rounded-2xl p-7 hover:bg-white/8 hover:border-[#FBC52D]/30 cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#FBC52D]/10 mb-5 group-hover:bg-[#FBC52D]/20 transition-colors">
                <i className={`${res.icon} text-[#FBC52D] text-xl`} />
              </div>
              <h3 className="text-white font-semibold text-base mb-2">{res.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-6">{res.desc}</p>

              <div className="pt-5 border-t border-white/10">
                <div className="text-[#FBC52D] text-2xl font-bold">{res.stat}</div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Strip */}
        <div className="res-card opacity-0 translate-y-6 transition-all duration-500 mt-12 flex flex-col md:flex-row items-center justify-between gap-6 bg-[#FBC52D]/10 border border-[#FBC52D]/25 rounded-2xl px-8 py-7">
          <div className="flex items-center gap-5">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#FBC52D]/15 shrink-0">
              <i className="ri-rocket-2-line text-[#FBC52D] text-xl" />
            </div>
            <div>
              <p className="text-white font-bold text-lg">Quer resultados como esses na sua empresa?</p>
              <p className="text-gray-400 text-sm">Converse com um especialista e descubra como a Ferrarezi acelera os resultados do seu negócio.</p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <button
              onClick={() => document.querySelector("#contato")?.scrollIntoView({ behavior: "smooth" })}
              className="whitespace-nowrap bg-[#FBC52D] text-black font-bold px-7 py-3 rounded-full hover:bg-[#d4a800] transition-colors text-sm cursor-pointer"
            >
              Fale com nossos especialistas
            </button>
            <a
              href="https://wa.me/5511936189998"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 border border-white/20 text-white font-semibold px-7 py-3 rounded-full hover:bg-white/10 transition-colors text-sm cursor-pointer"
            >
              <i className="ri-whatsapp-line" />
              WhatsApp
            </a>
          </div>
        </div>
      </div>

      <style>{`
        .res-visible {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}